const PORT: string = process.env.REACT_APP_PORT || '';
const BASE_URL: string = process.env.REACT_APP_BASE_URL || '';

export { PORT, BASE_URL };
